module.exports = __webpack_public_path__ + "static/media/postgresql-logo.a23eef34.png";